import Vue from 'vue';
import axios from 'axios';
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';

import filters from '@/components/filters/index.vue';
import addFileForm from '@/components/addFileForm/index.vue';
import dateSwitch from '@/components/dateSwitch/index.vue';
import search from '@/components/search/index.vue';
import tabView from '@/components/tabView/index.vue';
import taskJobView from '@/components/helpers/taskJobView/index.vue';
import pagination from '@/components/paginationSimple/index.vue';
import preloader from '@/components/preloader/index.vue';
import empty from '@/components/emptyContainer/index.vue';

import projectCreate from '@/components/project/create/index.vue';

import helpers from '@/mixins/helpers';

import Api from '@/utils/api';

export default Vue.extend({
  name: 'Projects',
  components: {
    filters,
    addFileForm,
    dateSwitch,
    tabView,
    Multiselect,
    DatePicker,
    search,
    taskJobView,
    pagination,
    preloader,
    projectCreate,
    empty,
  },
  mixins: [
    helpers.general,
  ],
  data () {
    return {
      projects: [],
      responseData: [],
      reportsDataTotal: 0,

      dateFilterSwitch: [],
      dateFilterCurrentView: '',

      exportFormat: '',
      exportFormats: [
        {
          name: 'pdf',
        }, {
          name: 'png',
        },
      ],
      exportInfo: {
        'message': '',
        'success': false,
      },

      filterParams: {
        name: 'projects?',
        url: '',
      },
      pagination: {
        page: 1,
        ppage: 6,
      },
      load: true,
      search: false,
      padding: 0,
    };
  },
  computed: {
    projectCreate () {
      return this.checkPermissions('project', 'project-create');
    },
    projectTotalCount () {
      return this.reportsDataTotal < this.pagination.ppage ? this.reportsDataTotal : this.pagination.ppage;
    },
  },
  watch: {
    pagination: {
      deep: true,
      handler() {
        this.getData();
      },
    },
  },
  created () {
    this.$store.dispatch('SHOW_PRELOADER', false);
  },
  mounted () {
    setTimeout(() => {
      this.scrollToTop();
    }, 1000);
  },
  methods: {
    scrollToTop() {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    },
    heightHandler (needHeight) {
      const neededPadding = needHeight - this.$refs.wrapper.offsetHeight;
      this.padding = neededPadding >= 0 ? neededPadding + 30 : 0;
    },
    dateSwitchJob (item) {
      this.dateFilterSwitch = item.value;
      this.dateFilterCurrentView = item.view;
    },

    holderSearch (searchString) {
      this.pagination.page = 1;
      this.load = true;
      this.search = searchString;
      this.getSearchProjects();
    },

    setFilters (params) {
      this.pagination.page = 1;
      this.load = true;
      this.filterParams = params;
      this.getFiltersProjects();
    },

    resetSearch () {
      this.search = '';
      this.getSearchProjects();
    },

    getSearchProjects () {
      Api.search('projects', this.search, { page: this.pagination.page, perPage: this.pagination.ppage })
        .then((data) => {
          this.holderResponse(data);
        });
    },

    getFiltersProjects () {
      this.load = true;

      Api.filters
        .sendFilters(this.filterParams, { page: this.pagination.page, perPage: this.pagination.ppage })
        .then((data) => {
          this.holderResponse(data);
          this.search = false;
        });
    },

    holderResponse (data) {
      if (data.data.Status) {
        this.projects = data.data.Data;
        this.responseData = data.data;
        this.reportsDataTotal = data.data.Total;
      } else {
        this.projects = [];
        this.responseData = [];
        this.reportsDataTotal = 0;
      }
      this.scrollToTop();
      this.load = false;
    },

    getData() {
      if (this.search) {
        this.getSearchProjects(this.search);
      } else {
        this.getFiltersProjects();
      }
    },

    selectExportFormat (event) {
      this.exportInfo.message = '';
      this.exportInfo.success = false;
    },

    exportProjects (filters) {
      var format = this.exportFormat.name;

      this.exportInfo.success = true;

      if (!format) {
        this.exportInfo.message = 'Please select format';
        return;
      }

      this.exportInfo.message = 'Download...';

      axios({
        url: this.$store.getters.rootAPI + '/filter/projects/export/' + format,
        method: 'POST',
        responseType: 'blob',
        data: filters,
      })
        .then((response) => {
          var a = document.createElement('a');
          var url = window.URL.createObjectURL(new Blob([response.data]));

          document.body.appendChild(a);
          a.style = 'display: none';
          a.href = url;
          a.download = 'projects.' + format;
          a.click();
          window.URL.revokeObjectURL(url);

          this.exportInfo.message = '';
          this.exportInfo.success = false;
        });
    },
  },
});
